/* global THREE */

import aframe from "aframe";
import geoGtlf from "../assets/missile-trail.json";

const geoPromise = new Promise(resolve => {
  new THREE.GLTFLoader().parse(JSON.stringify(geoGtlf), "", gltf => {
    gltf.scene.traverse(o => {
      if (o.name === "geo") {
        resolve(o.geometry);
      }
    });
  });
});

aframe.registerComponent("meshline", {
  multiple: true,
  schema: {
    color: { default: "#fff" },
    lineWidth: { default: 0.001 },
    start: { type: "vec3", default: "0 0 0" },
    end: { type: "vec3", default: "1 0 0" }
  },

  init() {
    this.o = new THREE.Mesh();
    const m = new THREE.MeshBasicMaterial({
      color: "red",
      side: THREE.DoubleSide
    });
    this.o.material = m;
    this.el.object3D.add(this.o);
    geoPromise.then(geo => {
      this.o.geometry = geo;
    });
    this.started = false;
  },

  update() {
    if (this.started) {
      this.setAttributes();
    }
  },

  play() {
    this.started = true;
    this.setAttributes();
  },

  tick() {
    this.setAttributes();
  },

  setAttributes: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    const v3 = new THREE.Vector3();
    const m1 = new THREE.Matrix4();

    return function (t, dt) {
      const o = this.o;
      o.position.copy(this.data.start);
      const end = v1.copy(this.data.end);
      const toEnd = end.sub(o.position);

      const toCamera = this.el.sceneEl.camera
        .getWorldPosition(v2)
        .sub(o.getWorldPosition(v3))
        .normalize();

      const lookMatrix = m1.lookAt(o.position, end, toCamera);
      o.setRotationFromMatrix(lookMatrix);
      o.scale.set(this.data.lineWidth, this.data.lineWidth, toEnd.length());
      o.material.color.set(this.data.color);
    };
  })()
});

/*
const getGameBoard = (() => {
  let gameBoardEl;
  return function() {
    if (!gameBoardEl) {
      gameBoardEl = document.querySelector("#game-board");
    }
    return gameBoardEl;
  };
})();
*/
